import { ProductData } from "../../../types/ProductService/ProductService";
import { translate } from "../../Translations/translatorService";
import { persistSettlement } from "../../Persist/SettlementPersister";
import { stageMetaDataSettlement } from "../../Stages/StagesSettlement";
import * as settlementStages from "../../Stages/StagesSettlement";
import * as settlementStatus from "../../LeadStatus/StatusSettlement";
import { paymentTypeSwitchDataSettlement } from "../PaymentTypeSwitchDataDefinitions/paymentTypeSwitchDataSettlement";
import settlementTransformations from "../FormTransformations/settlementTransformations";
import {
  stageFormDefinition as stageFormDefinitionSettlement
} from "../FormDefinitions/settlement/stageFormDefinition";
import formDefinitionExternals from "../FormDefinitions/externals";
import { fullFormDefinition as fullFormDefinitionSettlement } from "../FormDefinitions/settlement/fullFormDefinition";
import { inquiryTypeAvailability } from "../../inquiryService";
import { ProductUnion } from "../../../types/ProductUnion";
import { Settlement } from "../../../types/Products/EmploymentLaw/Settlement";
import { getProductData } from "./productService";

export const settlement: ProductData<Settlement> = {
  urlPart: "abfindung",
  lbUrlPart: "kuendigung",
  label: translate("settlement.label"),
  generalLabel: translate("settlement.label"),
  apiUri: "settlements",
  persist: persistSettlement,
  stages: stageMetaDataSettlement,
  stageConstants: settlementStages,
  minimumCaseStatus: settlementStatus.STATUS_DATA_COMPLETED,
  minimumCaseStage: settlementStages.STAGE_INCOMPLETE,
  setBackCaseStage: settlementStages.STAGE_READY,
  paymentType: {
    nwnf: "No-Win-No-Fee",
    insurance: "RSV",
    private: "Selbstzahler",
  },
  paymentTypeSwitchData: paymentTypeSwitchDataSettlement,
  courtAppointmentCreationAvailable: (product: ProductUnion) => product.stage >= settlementStages.STAGE_SUBMITTED,
  lbProductClass: "App\\Entity\\Legalbird\\EmploymentLaw\\Settlement\\Settlement",
  formTransformations: settlementTransformations,
  formDefinition: () => stageFormDefinitionSettlement,
  formDefinitionExternals: () => formDefinitionExternals["settlement"],
  fullFormDefinition: ({ product }) => fullFormDefinitionSettlement(product),
  productSpecificDefinition: () => [],
  productCategory: "employmentLaw",
  productSpecificBadges: ({}) => [],
  caseSubBarAdditionalInformation: ({}) => null,
  showCaseDescription: ({ product }) => {
    return product.stage >= getProductData(product.productClassName, "setBackCaseStage");
  },
  inquiryTypeAvailability: inquiryTypeAvailability.settlement,
};
